import type { FC } from "react";

import { SWReactIcons } from "@similarweb/icons";
import { IconButton, PlainTooltip } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import { proNavigator } from "single-spa/react-app/ProNavigator";
import { allTrackers } from "app/services/track/track";

import { SearchOverviewTexts } from "../../../../texts";
import type { IconButtonHref } from "../../types";

import { IconButtonWrapper, Container, Title, TitleContainer } from "./styledComponents";

interface SearchCardHeaderProps {
    title: string;
    tooltipText: string;
    iconButtonHref?: IconButtonHref;
}
const SearchCardHeader: FC<SearchCardHeaderProps> = ({ title, tooltipText, iconButtonHref }) => {
    const params = proNavigator.getParams();

    const handleIconClick = () => {
        allTrackers.dispatchTrackEvent("Internal Link", "click", `Overview/${iconButtonHref.eventSubName}`);
    };
    return (
        <Container>
            <TitleContainer>
                <Title>{title}</Title>
                <PlainTooltip
                    enabled={!!tooltipText}
                    tooltipContent={translate(tooltipText)}
                >
                    <span>
                        <SWReactIcons
                            iconName="info"
                            size="xs"
                        />
                    </span>
                </PlainTooltip>
            </TitleContainer>
            {iconButtonHref ? (
                <PlainTooltip tooltipContent={translate(SearchOverviewTexts.seeMore)}>
                    <IconButtonWrapper
                        onClick={handleIconClick}
                        href={proNavigator.href(iconButtonHref.href, params)}
                    >
                        <IconButton
                            iconName={iconButtonHref.name}
                            type="flat"
                            iconSize="xs"
                        />
                    </IconButtonWrapper>
                </PlainTooltip>
            ) : null}
        </Container>
    );
};

export default SearchCardHeader;
